<div id="dashboard-project" class="page-layout simple right-sidenav" fxLayout="row" style="height: 100%" perfect-scrollbar>


  <!-- CENTER -->
  <div class="center" fxFlex style="height: 100%" perfect-scrollbar>

    <!-- HEADER -->
    <div class="header thin-header mat-accent-bg p-12 p-sm-24" fxLayout="column" fxLayoutAlign="space-between">

      <div fxFlex="" fxLayoutAlign="start center">
        <span class="logo-text h1">Dee's Super Duper JSON Schema Testing Page</span>
      </div>


      <div fxLayout="row">
      </div>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->

    <div class="content">

      <button type="button" mat-raised-button color="accent" (click)="docUpload.click()"  >
        <span>Upload .json file</span>
      </button>
      <input hidden type="file" #docUpload (change)="upload($event)"/>

      <br/><br/>

      <span *ngIf="loading">No Schema...</span>
      <mat-horizontal-stepper *ngIf="!loading" (selectionChange) = "stepperSelectionChange($event)" id="formStepper" #stepper>
        <mat-step *ngFor="let data of jsonSchema; let i = index;" label="Step {{ i+1 }}">
          <!--
              the onChanges
              this saves the form anytime the user changes something
              on load this gives an error because we are in dev
              https://github.com/angular/angular/issues/6005
              it seems it is ignorable
          -->
          <json-schema-form *ngIf="i == currentPage"
                            [form]="jsonSchema[currentPage]"
                            [data]="jsonSchema[currentPage].data"
                            framework="material-design"
                            (onChanges)="formChange($event)"
                            (onSubmit)="goForward(stepper)">
          </json-schema-form>

          <button
            mat-raised-button class="pull-right space " color="accent"
            (click)="goForward(stepper)"
            *ngIf="currentPage != ( jsonSchema.length - 1 )"
            style="margin-left: 10px; margin-top : 35px ;"
          >Next</button>&nbsp;&nbsp;

          <button
            mat-raised-button class="pull-right space" color="warn"
            (click)="goBack(stepper)"
            *ngIf="currentPage != 0"
            style="margin-left: 10px; margin-top : 35px ;"
          >Back</button>&nbsp;

        </mat-step>
      </mat-horizontal-stepper>

    </div>
    <!-- / CONTENT -->

  </div>
  <!-- / CENTER -->

</div>



// WEBPACK FOOTER //
// ./src/app/main/content/dee/dee.component.html